// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HorizontalStackedNounsBR_wrapper__35B7c","nounbrWrapper":"HorizontalStackedNounsBR_nounbrWrapper__5rTXH"};